import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  dialogWrapper: {
    maxWidth: 700,
    width: "100%",
  },
  titleFiled: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "24px",
    color: theme.palette.text.secondary,
    maxWidth: "280px",
    minWidth: "190px",
  },
  containerInputSection: {
    display: "flex",
    justifyContent: "space-between",
    gap: "32px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      width: "90vw",
    },
  },
  bannerBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "20px 0",
    background: theme.palette.background.brand_50,
    border: `1px solid ${theme.palette.border.brand}`,
    borderRadius: "12px",
    padding: "16px",

    "& .MuiAlert-message": {
      width: "100%",
    },
  },
  taxWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  fieldsSection: {
    "& > * + *": {
      marginTop: "20px",
      paddingTop: "20px",
      borderTop: `1px solid ${theme.palette.border.main}`,
    },
    "& label": {
      minWidth: "190px",
    },
    "& .FBFieldWrapper": {
      width: "100%",
    },
    "& .text-field-wrapper > div": {
      width: "100% !important",
    },
    "& .autocomplete": {
      width: "100% !important",
    },
  },
  statusOptions: {
    width: "430px",
    display: "flex",
    gap: "16px",
  },
  footerActions: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    justifyContent: "flex-end",
    paddingTop: "24px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "80px",
    },
  },
  inputField: {
    maxWidth: "100%",
  },
}));
